import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import MontageMeetingStatus, {
  MontageMeetingStatusFormSend,
  UpdateMontageMeetingStatusFormSend,
} from "@/interfaces/MontageMeetingStatus";
import api from "@/services/api";

export const montageMeetingStatuses = api.injectEndpoints({
  endpoints: (build) => ({
    getMontageMeetingStatuses: build.query<
      IPaginateResponse<MontageMeetingStatus>,
      IFilters
    >({
      query: (params) => ({ url: `/montage-meeting-statuses`, params }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "MontageMeetingStatuses" as const,
                id,
              })),
              { type: "MontageMeetingStatuses" as const, id: "LIST" },
            ]
          : [{ type: "MontageMeetingStatuses" as const, id: "LIST" }],
    }),
    getMontageMeetingStatus: build.query<MontageMeetingStatus, string>({
      query: (id) => `/montage-meeting-statuses/${id}`,
      providesTags: (_r, _e, id) => [{ type: "MontageMeetingStatuses", id }],
    }),
    storeMontageMeetingStatus: build.mutation<
      MontageMeetingStatus,
      MontageMeetingStatusFormSend
    >({
      query: (body) => ({
        url: `/montage-meeting-statuses`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "MontageMeetingStatuses", id: "LIST" }],
    }),
    updateMontageMeetingStatus: build.mutation<
      MontageMeetingStatus,
      [string, UpdateMontageMeetingStatusFormSend]
    >({
      query: ([id, body]) => ({
        url: `/montage-meeting-statuses/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "MontageMeetingStatuses", id: "LIST" }],
    }),
    deleteMontageMeetingStatus: build.mutation<void, string>({
      query: (id) => ({
        url: `/montage-meeting-statuses/${id}`,
        method: "DELETE",
      }),
      // Supprimer un statut rebascule ses rendez-vous : le calendrier montage
      // doit se rafraîchir, pas seulement la liste des statuts.
      invalidatesTags: [
        { type: "MontageMeetingStatuses", id: "LIST" },
        { type: "MontageMeetings", id: "LIST" },
      ],
    }),
  }),

  overrideExisting: true,
});

export const {
  useGetMontageMeetingStatusesQuery,
  useLazyGetMontageMeetingStatusesQuery,
  useGetMontageMeetingStatusQuery,
  useStoreMontageMeetingStatusMutation,
  useUpdateMontageMeetingStatusMutation,
  useDeleteMontageMeetingStatusMutation,
} = montageMeetingStatuses;
